import React from 'react';
import Spinner from '../UI/Spinner';
import classNames from 'classnames';

interface ButtonWithLoaderProps {
  loading: boolean;
  message: string;
  disabled?: boolean;
  type?: 'submit' | 'button';
  onClick?: () => void;
  className?: string;
  dataCy?: string;
}

export function ButtonWithLoader({
  loading,
  disabled = false,
  message,
  type = 'submit',
  onClick,
  className,
  dataCy,
}: ButtonWithLoaderProps) {
  return (
    <button
      type={type === 'submit' ? 'submit' : 'button'}
      disabled={disabled}
      className={classNames(
        `mx-auto my-12 flex h-16 w-full cursor-pointer items-center justify-center rounded-full bg-blue-light text-lg
        font-bold text-white shadow-md transition hover:bg-cyan-600 hover:shadow-lg disabled:cursor-not-allowed
        disabled:opacity-60 md:px-4`,
        className,
      )}
      onClick={onClick}
      data-cy={dataCy}
    >
      {loading ? (
        <Spinner width={18} height={18} borderwidth={3} color="white" />
      ) : (
        <span>{message}</span>
      )}
    </button>
  );
}
